export const newLabelsSearch = (state) => state.rootReducer.postsLibrary.newLabelsSearch;

export const labelsSearchStatus = (state) => state.rootReducer.postsLibrary.labelsSearchStatus;